import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TheProblem from './components/TheProblem';
import TheresTheTruth from './components/TheresTheTruth';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import YourOnlyJob from './components/YourOnlyJob';
import PerfectForYouIf from './components/PerfectForYouIf';
import AlignedIncentives from './components/AlignedIncentives';
// import TestimonialCarousel from './components/TestimonialCarousel';
import About from './components/About';
import ContactForm from './components/ContactForm';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import './App.css';

function MainPage() {
  return (
    <>
      <Navbar />
      <Hero />
      <TheProblem />
      <TheresTheTruth />
      <Features />
      <HowItWorks />
      <YourOnlyJob />
      <PerfectForYouIf />
      <AlignedIncentives />
      {/* <TestimonialCarousel /> */}
      <About />
      <ContactForm />
      <FAQ />
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
